import { create } from 'zustand';
import { persist } from 'zustand/middleware';
// ¡Ya no necesitamos 'useShallow' aquí!

const useSearchStore = create(
  persist(
    (set) => ({
      products: [],
      productsByRecipe: {},
      activeRecipeId: null,
      
      initializeRecipeProducts: (initialData) =>
        set({ productsByRecipe: initialData }),
        
      setActiveRecipeId: (recipeId) => set({ activeRecipeId: recipeId }),

			incrementQuantity: (newProduct) =>
				set((state) => {
					// Busca si el producto ya existe
					const existingProductIndex = state.products.findIndex(
						(product) => product.sku === newProduct.sku
					);
			
					if (existingProductIndex !== -1) {
						// Si existe, incrementa la cantidad
						const updatedProducts = [...state.products];
						updatedProducts[existingProductIndex] = {
							...updatedProducts[existingProductIndex],
							quantity: updatedProducts[existingProductIndex].quantity + 1
						};
						return { products: updatedProducts };
					} else {
						// Si no existe, agrega el nuevo producto
						return { products: [newProduct, ...state.products] };
					}
				}),
      
      clearProductsForRecipe: (recipeId) =>
        set((state) => {
          const newProductsByRecipe = { ...state.productsByRecipe };
          delete newProductsByRecipe[recipeId];
          return { productsByRecipe: newProductsByRecipe };
        }),
      
      updateProductQuantity: (sku, newQuantity) =>
        set((state) => {
          const { activeRecipeId } = state;
          const qty = Math.max(1, newQuantity);
  
          if (activeRecipeId) {
            // Lógica de Recetas
            const recipeProducts = state.productsByRecipe[activeRecipeId] || [];
            const updatedProducts = recipeProducts.map((p) =>
              p.sku === sku ? { ...p, quantity: qty } : p,
            );
            return {
              productsByRecipe: {
                ...state.productsByRecipe,
                [activeRecipeId]: updatedProducts,
              },
            };
          } else {
            // Lógica Original (Fallback)
            const updatedProducts = state.products.map((p) =>
              p.sku === sku ? { ...p, quantity: qty } : p,
            );
            return { products: updatedProducts };
          }
        }),

      setProducts: (newProduct) => set(() => ({ products: newProduct })),
      
      addProduct: (newProduct) =>
        set((state) => {
          const { activeRecipeId } = state;
          if (activeRecipeId) {
            // Lógica de Recetas
            const recipeProducts = state.productsByRecipe[activeRecipeId] || [];
            if (!recipeProducts.some((p) => p.sku === newProduct.sku)) {
              const updatedProducts = [newProduct, ...recipeProducts];
              return {
                productsByRecipe: {
                  ...state.productsByRecipe,
                  [activeRecipeId]: updatedProducts,
                },
              };
            }
            return state;
          } else {
            // Lógica Original (Fallback)
            if (!state.products.some((p) => p.sku === newProduct.sku)) {
              return { products: [newProduct, ...state.products] };
            }
            return state;
          }
        }),
        
      deleteProduct: (sku) =>
        set((state) => {
          const { activeRecipeId } = state;
          if (activeRecipeId) {
            // Lógica de Recetas
            const recipeProducts = state.productsByRecipe[activeRecipeId] || [];
            const updatedProducts = recipeProducts.filter((p) => p.sku !== sku);
            return {
              productsByRecipe: {
                ...state.productsByRecipe,
                [activeRecipeId]: updatedProducts,
              },
            };
          } else {
            // Lógica Original (Fallback)
            return { products: state.products.filter((p) => p.sku !== sku) };
          }
        }),
      
      addProducts: (newProducts) =>
        set((state) => {
          const uniqueProducts = newProducts.filter((newProduct) => !state.products.some((product) => product.sku === newProduct.sku));
          return { products: [...uniqueProducts, ...state.products] };
        }),
      
      // --- ¡LA FUNCIÓN 'incrementQuantity' (LA ANTIGUA) SE ELIMINA! ---
      
    }),
    {
      name: 'search-list-storage',
      getStorage: () => sessionStorage,
    },
  ),
);

// --- ¡EL SELECTOR 'useProductSectionStore' SE ELIMINA! ---
// (Esta era la causa de la race condition)

export default useSearchStore;